import { render } from "./SelectPropsCmp.vue?vue&type=template&id=b7581d12"
import script from "./SelectPropsCmp.vue?vue&type=script&lang=js"
export * from "./SelectPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__